/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { abstractLitigationCaseValidators } from "../AbstractLitigationCase/abstractLitigationCaseValidators";
import * as stages from "../../Stages/StagesAdministrativeLaw";

export const civilServiceLawValidators = {
  ...abstractLitigationCaseValidators,
  [stages.STAGE_ADMINISTRATIVE_PROCEEDINGS]: () => [],
  [stages.STAGE_ADMINISTRATIVE_DECISION_ISSUED]: () => [],
};
